import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { Userpilot } from 'userpilot';

import { setEnvironment, environment } from './environments/environment';
import { setBrokerUrl } from './app/socket/ada-rx-stomp.config';

fetch('/wsasapi/environment').then(res => res.json()).then((res) => {

  setEnvironment(res['obj']);
  setBrokerUrl(environment.socketUrl);

  if (environment.production) {
    enableProdMode();
  }

  Userpilot.initialize(environment.userpilot_token);

  platformBrowserDynamic().bootstrapModule(AppModule);

});